import React, { useState } from "react";
import imageStyle from "../component/imageSwiper.module.css";
import Carousel from "better-react-carousel";
import Images from "./Images";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation, FreeMode, Thumbs, Autoplay, Pagination } from "swiper";

const styles = {
  imageStyle: {
    maxWidth: "100%",
    width: "100%",
    aspectRatio: "16/9",
    objectFit: "cover",
    objectPosition: "top",
  },
};

const glimpsData = [

]
const ImageSwiper = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return (
    <section className={imageStyle.sliderSection}>
      <div className="container-fluid">
        <h2>Stand On Your Feet 2023 Glimpses​</h2>
        <>
          <Swiper
            id="imageSwiper"
            modules={[Autoplay, Navigation, FreeMode, Thumbs, Pagination]}
            loop={true}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true, // Enable clickable pagination bullets
              // el: ".swiper-pagination", // Element to render pagination bullets
            }}
            navigation={true}
            thumbs={{
              swiper:
                thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
            }}
            className={imageStyle.mySwiper2}
            style={{
              "--itemsCount": 7,
            }}
          >
            {glimpsData?.map((item, index) => (
              <SwiperSlide key={item.id}>
                <img loading="lazy" src={item.image.src} style={styles.imageStyle} />
              </SwiperSlide>
            ))}
            <SwiperSlide>
              <img loading="lazy" src={Images.glimps2} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img loading="lazy" src={Images.glimps3} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img loading="lazy" src={Images.glimps4} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img loading="lazy" src={Images.glimps5} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img loading="lazy" src={Images.glimps6} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img loading="lazy" src={Images.glimps7} style={styles.imageStyle} />
            </SwiperSlide>
          </Swiper>
          {/* <Swiper
            onSwiper={setThumbsSwiper}
            loop={true}
            spaceBetween={10}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className={imageStyle.mySwiper}
          >
            <SwiperSlide>
              <img src={Images.glimps1} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Images.glimps2} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Images.glimps3} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Images.glimps4} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Images.glimps5} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Images.glimps6} style={styles.imageStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Images.glimps7} style={styles.imageStyle} />
            </SwiperSlide>
          </Swiper> */}
        </>
      </div>
    </section>
  );
};

export default ImageSwiper;
